<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .manager-status-banner {
    align-items: center;
    border-radius: utils.in_rem(70px);
    display: flex;
    gap: utils.in_rem(8px);
    justify-content: center;
    padding: utils.in_rem(8px) utils.in_rem(12px);
    width: 100%;

    &.listen {
      background-color: colors.get(interfaceSwGrey_20);
      color: colors.get(primary_80);
    }

    &.coach {
      background-color: colors.get(primary_50);
      color: colors.get(textWhite);
    }

    &.participate {
      background-color: colors.get(accentStatusSeaGreen);
      color: colors.get(textWhite);
    }

    .icon {
      font-size: utils.in_rem(14px);
    }

    .text {
      @include mixins.body4;
      font-weight: 600;
      letter-spacing: utils.in_rem(0.2px);
    }
  }
</style>

<script>
  import Icon from "../../../../../../svelte-design-system/components/atoms/Icon.svelte";

  let { mode = "listen", userName = "" } = $props();

  const getIcon = (mode) => {
    switch (mode) {
      case "participate":
        return "fa-microphone-stand";
      case "coach":
        return "fa-headphones";
      case "listen":
      default:
        return "fa-ear";
    }
  };

  const getText = (mode, name) => {
    switch (mode) {
      case "participate":
        return "Participating - Everyone can hear you";
      case "coach":
        return `Coaching - Only ${name} can hear you`;
      case "listen":
        return "Listening - No one can hear you";
      default:
        return "";
    }
  };
</script>

<div class="manager-status-banner {mode}">
  <Icon class="fa-regular {getIcon(mode)}" size="small" />
  <span class="text">{getText(mode, userName)}</span>
</div>
